import { X } from 'lucide-react'
import type { ReactNode } from 'react'

interface TagProps {
  children: ReactNode
  /** 10x10 leading colour square, used for status and chart legends. */
  swatch?: string
  onDismiss?: () => void
  title?: string
}

/** background-body fill, no border, no radius, Mulish 12. Never interactive except the X. */
export function Tag({ children, swatch, onDismiss, title }: TagProps) {
  return (
    <span
      className="inline-flex items-center font-mulish text-white"
      style={{ backgroundColor: '#1A1D21', padding: '6px 12px', gap: 4, fontSize: 12, lineHeight: 'normal' }}
      title={title}
    >
      {swatch && <span style={{ width: 10, height: 10, backgroundColor: swatch, display: 'block', flexShrink: 0 }} />}
      {children}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Remove"
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex' }}
        >
          <X size={12} className="text-text-support" />
        </button>
      )}
    </span>
  )
}
